import CalendarIcon from "@redotech/redo-icons/calendar.svg";
import XIcon from "@redotech/redo-icons/x-close.svg";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoIcon } from "@redotech/redo-web/arbiter-components/icon/redo-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";
import { useConversionLockedAction } from "./use-conversion-locked-action";

// Hex values come straight from the Figma node 40:3964 (CRO-1387). The shared
// `bgColor` prop doesn't expose the dark-rail surface color, so an inline
// background is the lightest-weight match.
const CARD_BG = "#292929";
const TITLE_COLOR = "#fafafa";
const BODY_COLOR = "#d6d6d6";

/**
 * Promo card pinned at the bottom of the Conversion Cloud sidebar for
 * intent-only teams (CRO-1387). Pitches the rest of the suite and routes
 * the merchant to a sales call when clicked.
 *
 * Dismissal is component-state only — no persistence — so the card
 * re-appears on every page reload / new session by design.
 */
export const IntentOnlySidebarPromo = memo(function IntentOnlySidebarPromo() {
  const [dismissed, setDismissed] = useState(false);
  const { onLockedClick } = useConversionLockedAction(
    ScheduleDemoButtonLocation.INTENT_SIDEBAR_PROMO,
  );

  if (dismissed) {
    return null;
  }

  return (
    <Flex
      dir="column"
      gap="lg"
      mt="auto"
      mx="md"
      p="xl"
      style={{ backgroundColor: CARD_BG, borderRadius: 8 }}
    >
      <Flex align="flex-start" dir="row" gap="lg" justify="space-between">
        <Text color={TITLE_COLOR} fontSize="xs" fontWeight="semibold">
          Unlock more revenue per visitor
        </Text>
        <button
          aria-label="Dismiss"
          onClick={() => setDismissed(true)}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: 0,
            lineHeight: 0,
          }}
          type="button"
        >
          <RedoIcon color="tertiary" Icon={XIcon} size={16} />
        </button>
      </Flex>
      <Text
        color={BODY_COLOR}
        fontSize="xs"
        fontWeight="regular"
        style={{ opacity: 0.8 }}
      >
        Upgrade Conversion Cloud to add AI shipping pricing, post-purchase
        upsells, and customer segmentation to capture revenue you&rsquo;re
        leaving on the table.
      </Text>
      <RedoButton
        hierarchy="primary"
        IconLeading={CalendarIcon}
        onClick={() => void onLockedClick()}
        size="sm"
        text="Schedule a call"
        theme="normal"
      />
    </Flex>
  );
});
